"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _ComponentWithUniqueIds = _interopRequireDefault(require("../mixins/ComponentWithUniqueIds"));

var _UIIcon = _interopRequireDefault(require("../icon/UIIcon"));

var _UIFormLabel = _interopRequireDefault(require("../form/UIFormLabel"));

var _validateUIFormControlValidationMessage = _interopRequireDefault(require("../form/utils/validateUIFormControlValidationMessage"));

var _UICheckbox = _interopRequireDefault(require("../input/UICheckbox"));

var _UITooltip = _interopRequireDefault(require("../tooltip/UITooltip"));

var _PlacementConstants = require("../tooltip/PlacementConstants");

var _elements = require("../elements");

var _Deprecated = _interopRequireDefault(require("../decorators/Deprecated"));

/**
 * Group a form field, label, notes, and errors/alerts together
 **/
var UILegacyFormControl = _react.default.createClass({
  displayName: "UILegacyFormControl",
  mixins: [_ComponentWithUniqueIds.default],
  propTypes: {
    /**
     * Instructional text to display with the field label
     **/
    'aria-label': _react.PropTypes.string,

    /**
     * Pass the form input as a child. Label will be linked by provided ID, or
     * a random unique ID will be assigned to the input for linking.
     **/
    children: _react.PropTypes.node.isRequired,

    /**
     * Detailed description of component. Similar to `help` but more in-depth
     **/
    description: _react.PropTypes.node,

    /**
     * `true` indicates this field is in an error state
     * DEPRECATED: or pass an error string to have it displayed at the bottom of the input
     **/
    error: _react.PropTypes.bool,

    /**
     * Message to be displayed at the bottom of the input
     *
     * By default the text is green
     * If `error` is set to `true` then the text is red
     **/
    validationMessage: _react.PropTypes.node,

    /**
     * Instructional text to display with the field label
     **/
    help: _react.PropTypes.node,

    /**
     * `id` attribute of the input field you want label to be bound to
     *
     * By default, the `<label />` will be linked to the embedded `<input />`
     * using the `for` attribute. Use this if you need to override that behavior
     **/
    htmlFor: _react.PropTypes.string,

    /**
     * Renders a clickable <UIFormLabel /> alongside input with this text as content
     **/
    label: _react.PropTypes.node,

    /**
     * Class name for the rendered <UIFormLabel /> component
     **/
    labelClassName: _react.PropTypes.string,

    /**
     * `true` indicates the field is required and will be styled accordingly
     **/
    required: _react.PropTypes.bool.isRequired,

    /**
     * Instructional text to display with the the '?' icon and tooltip
     **/
    tooltip: _react.PropTypes.node,

    /**
     * Placement of the tooltip
     **/
    tooltipPlacement: _react.PropTypes.oneOf(_PlacementConstants.PLACEMENTS).isRequired
  },
  getDefaultProps: function getDefaultProps() {
    return {
      error: false,
      required: false,
      tooltipPlacement: 'top'
    };
  },
  getHtmlFor: function getHtmlFor(propValue, children) {
    var firstChild = _react.Children.only(children);

    if (propValue) {
      return propValue;
    }

    if (firstChild) {
      var _firstChild$props = firstChild.props,
          name = _firstChild$props.name,
          id = _firstChild$props.id;
      return id || name;
    }

    return null;
  },
  getClasses: function getClasses(_ref) {
    var className = _ref.className,
        description = _ref.description,
        error = _ref.error,
        label = _ref.label;
    return (0, _classNames.default)('private-form__set', 'private-form__set--legacy', className, {
      'private-form__set--error': !!error,
      'private-form__set--with-details': !!description,
      'private-form__set--no-label': !label
    });
  },
  renderValidation: function renderValidation(_ref2) {
    var error = _ref2.error,
        validationMessage = _ref2.validationMessage;
    var validationClass = 'private-form__validation';

    if (validationMessage) {
      (0, _validateUIFormControlValidationMessage.default)({
        error: error,
        validationMessage: validationMessage
      });
      return _react.default.createElement(_elements.Small, {
        className: validationClass,
        use: error ? 'error' : 'success'
      }, validationMessage);
    }

    if (error && typeof error === 'string') {
      _devLogger.default.warn({
        message: 'UIFormControl: Use of error property as a string is deprecated, please use' + ' `validationMessage` paired with a boolean value for `error` instead.',
        key: 'UIFormControl: error string'
      });

      return _react.default.createElement(_elements.Small, {
        className: validationClass,
        use: "error"
      }, error);
    }

    return null;
  },
  renderTooltip: function renderTooltip(_ref3) {
    var tooltip = _ref3.tooltip,
        tooltipPlacement = _ref3.tooltipPlacement;
    if (!tooltip) return null;
    return _react.default.createElement(_UITooltip.default, {
      placement: tooltipPlacement,
      title: tooltip
    }, _react.default.createElement(_UIIcon.default, {
      className: "private-form__help-tooltip",
      name: "info",
      tabIndex: 0
    }));
  },
  renderHelp: function renderHelp(_ref4, _ref5) {
    var help = _ref4.help;
    var renderedInput = _ref5.renderedInput;
    var labelledBy = renderedInput && renderedInput.props && renderedInput.props.id;

    if (help) {
      return _react.default.createElement("span", {
        "aria-labelledby": labelledBy,
        className: "private-form__inlinehelp"
      }, help);
    }

    return null;
  },
  renderDescription: function renderDescription(_ref6) {
    var description = _ref6.description;
    if (!description) return null;
    return _react.default.createElement("div", {
      className: "private-form__desc"
    }, _react.default.createElement(_elements.Small, {
      use: "help"
    }, description));
  },
  renderInput: function renderInput(_ref7) {
    var ariaLabel = _ref7.ariaLabel,
        children = _ref7.children,
        error = _ref7.error,
        required = _ref7.required;

    var child = _react.Children.only(children);

    var _child$props = child.props,
        id = _child$props.id,
        name = _child$props.name,
        origRequired = _child$props.required; // only add id prop if input doesn't have it already
    // or if both name and id are empty, bail and just return as-is

    var newId = id != null ? id : this.getUniqueId(name || 'ctrl'); // if the child input doesn't declare `required`, pass it down

    var newRequired = required === true ? true : origRequired;
    var cloneProps = {
      'aria-label': ariaLabel,
      id: newId,
      required: newRequired,
      'aria-required': newRequired
    }; // only add error prop if there is an error, to avoid potential "Unknown prop" warnings

    if (error) {
      cloneProps.error = !!error;
    }

    return (0, _react.cloneElement)(child, cloneProps);
  },
  renderLabel: function renderLabel(_ref8, _ref9) {
    var ariaLabel = _ref8.ariaLabel,
        children = _ref8.children,
        label = _ref8.label,
        labelClassName = _ref8.labelClassName,
        error = _ref8.error,
        htmlFor = _ref8.htmlFor,
        required = _ref8.required;
    var renderedInput = _ref9.renderedInput;

    if (!label && !ariaLabel && _react.Children.only(children).type !== _UICheckbox.default) {
      _devLogger.default.warn({
        message: "UIFormControl: For better accessibility, if you're going to omit `label`, please include an `aria-label` property.",
        key: 'UIFormControl: add aria-label'
      });
    }

    if (!label) return null;
    return _react.default.createElement(_UIFormLabel.default, {
      className: labelClassName,
      error: !!error,
      htmlFor: this.getHtmlFor(htmlFor, renderedInput),
      required: required
    }, label);
  },
  render: function render() {
    var _this$props = this.props,
        ariaLabel = _this$props['aria-label'],
        children = _this$props.children,
        className = _this$props.className,
        description = _this$props.description,
        error = _this$props.error,
        validationMessage = _this$props.validationMessage,
        help = _this$props.help,
        htmlFor = _this$props.htmlFor,
        label = _this$props.label,
        labelClassName = _this$props.labelClassName,
        required = _this$props.required,
        tooltip = _this$props.tooltip,
        tooltipPlacement = _this$props.tooltipPlacement,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["aria-label", "children", "className", "description", "error", "validationMessage", "help", "htmlFor", "label", "labelClassName", "required", "tooltip", "tooltipPlacement"]);
    var classes = this.getClasses({
      className: className,
      description: description,
      error: error,
      label: label
    });
    var renderedInput = this.renderInput({
      ariaLabel: ariaLabel,
      children: children,
      error: error,
      required: required
    });
    return _react.default.createElement("div", (0, _extends2.default)({
      className: classes
    }, rest), _react.default.createElement("div", {
      className: "private-form__control-wrapper"
    }, this.renderLabel({
      ariaLabel: ariaLabel,
      children: children,
      label: label,
      labelClassName: labelClassName,
      error: error,
      htmlFor: htmlFor,
      required: required
    }, {
      renderedInput: renderedInput
    }), this.renderTooltip({
      tooltip: tooltip,
      tooltipPlacement: tooltipPlacement
    }), this.renderHelp({
      help: help
    }, {
      renderedInput: renderedInput
    }), _react.default.createElement("div", {
      className: "private-form__input-wrapper"
    }, renderedInput), this.renderValidation({
      error: error,
      validationMessage: validationMessage
    })), this.renderDescription({
      description: description
    }));
  }
});

var _default = (0, _Deprecated.default)('You are using `UIComponents/legacy/UIFormControl`. Use `UIComponents/form/UIFormControl` instead.', 'https://git.hubteam.com/HubSpot/UIComponents/issues/5906')(UILegacyFormControl);

exports.default = _default;
module.exports = exports.default;